.kx{color:var(--gray-900);}